import { devisMismatch } from "@/lib/documentAmounts";

const formatEur = (v) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(v || 0);

/** Avertit quand une facture de solde ne totalise plus la même somme que son devis.
 *
 *  Corriger les lignes du brouillon du solde change son total sans toucher au devis, que
 *  le PDF cite pourtant en référence : un client qui compare lit deux totaux. On INFORME,
 *  on ne propage rien — réécrire un devis signé serait pire. Le total du devis vient du
 *  serveur (`devis_total_ttc`), jamais d'une requête par ligne de liste.
 */
export const DevisMismatchWarning = ({ doc, suffix = "" }) => {
  const ecart = devisMismatch(doc);
  if (!ecart) return null;
  const reference = ecart.devisNumber ? `du devis ${ecart.devisNumber}` : "du devis d'origine";
  return (
    <div
      className="text-[10px] font-normal text-amber-700"
      title={`Cette facture de solde totalise ${formatEur(ecart.docTtc)} alors que ${reference} totalise ${formatEur(ecart.devisTtc)}. Le devis n'est pas modifié : vérifiez lequel des deux documents fait foi.`}
      data-testid={`devis-mismatch${suffix}-${doc.id}`}
    >
      Total différent {reference} ({formatEur(ecart.docTtc)} contre {formatEur(ecart.devisTtc)})
    </div>
  );
};
